exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__newsAgenda___1MRS6{display:grid;grid-template-rows:auto;grid-gap:1rem}@media (min-width:768px){.index-module__newsAgenda___1MRS6{grid-template-columns:1fr}}@media (min-width:1325px){.index-module__newsAgenda___1MRS6{grid-template-columns:3.12fr 1fr}}", ""]);

// exports
exports.locals = {
	"newsAgenda": "index-module__newsAgenda___1MRS6"
};